import {RootState} from 'App/store/rootReducer';

export const selectedAutoResult =
  (tenement: string | null) =>
  (state: RootState): number | null => {
    if (!tenement) {
      return null;
    }
    if (tenement in state.autoResults.selectedAutoResults) {
      return state.autoResults.selectedAutoResults[tenement];
    }

    return null;
  };
